// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/Price/Price.css
// module id = 1614
// module chunks = 0